<template>
    <div class="checkWrapper">
    <div class="checkTitle">
      <div v-html="title"></div>
      <div class="checkBox" @click="value=!value">
        <div v-if="value" class="checkMark"></div> 
     </div>
  </div>
  </div>
</template>

<script>
export default {
    name: "wdmSmallCheckmark",
    props: ['modelValue', 'title'],
    emits: ['update:modelValue'],
    computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>

<style scoped>

.checkWrapper {
  display:flex;
  cursor:pointer;
  
}

.checkBox {
  width:13px;
  height:13px;
  border: solid 3px black;
  border-radius:3px;
  margin-left:5px;
  background-color: white;
}
.checkTitle {
  display:flex;
  margin: auto;
  align-items: center;
}
.checkMark {
  position: relative;
  left: 3px;
  top: 1px;
  width:4px;
  height:7px;
  border: solid var(--nomeco-green);
  border-width: 0px 3px 3px 0px;
  -webkit-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  transform: rotate(35deg);
}
</style>